import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Hero } from '../components/Hero'
import { OurPartners } from '../components/OurPartners'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { Card } from '@app/components/blocks/card/Card'
import IndependentLadiesImage from 'tenants/steunpunt-amsterdam/assets/images/landing/independent-ladies.png'
import PeopleLookingForAHouse from '@app/assets/images/people_looking_for_house.png'
import PersonWithBinocularsImage from '@app/assets/images/person_with_binoculars.png'
import woonInfo from '@app/assets/images/partners/woon.png'
import NeverAloneImage from 'tenants/steunpunt-amsterdam/assets/images/landing/never-alone.png'
import PersonHoldingANut from '@app/assets/images/person_holding_a_nut_screw.svg'
import { Image } from '@app/components/core/image/Image'
import { Button } from '@app/components/core/button/Button'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import { ColumnsSection } from '@app/components/blocks/contentSection/ColumnsSection'
import { LandingStoryCards } from '../components/LandingStoryCards'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { SignupFormModal } from '../components/SignupFormModal'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { TextLink } from '@app/components/core/link/TextLink'
import { LandingEvents } from '../components/LandingEvents'

export const Landing = () => {
  const isMobile = useMediaQuery()
  const { email: tenantEmail } = useTenantContext()
  const t = useTranslations().app
  const tSteunpunt = t.steunpuntAmsterdam

  return (
    <PageLayout gap={isMobile ? '6rem' : '10rem'}>
      <div>
        <Hero style={{ marginBottom: '4rem' }} />

        <OurPartners />
      </div>

      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '3rem',
          }}
        >
          <Title.H2 style={{ marginBottom: 0 }}>
            {tSteunpunt.landing.agenda.title}
          </Title.H2>
          <TextLink to={pages.events} icon={faArrowRight} size="medium">
            {t.common.seeMore}
          </TextLink>
        </div>
        <LandingEvents
          style={{
            marginRight: 'calc(50% - 50vw)',
            overflowX: 'auto',
          }}
        />
      </div>

      <div id="over-steunpunt">
        <Title.H2 style={{ marginBottom: '2rem' }}>
          {tSteunpunt.landing.aboutUs.title}
        </Title.H2>
        <ColumnsSection
          columns={[
            {
              content: (
                <Text.Medium style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.aboutUs.text}
                </Text.Medium>
              ),
            },
            {
              content: (
                <Image
                  src={woonInfo}
                  alt="Woon Info logo"
                  style={{ width: '80%', marginLeft: 'auto' }}
                  resizeWidth={200}
                />
              ),
            },
          ]}
        />
      </div>

      <div>
        <Title.H2 style={{ marginBottom: isMobile ? '2rem' : '4rem' }}>
          {tSteunpunt.landing.whyCollectiveLiving.title}
        </Title.H2>
        <div
          style={{
            display: isMobile ? 'flex' : 'grid',
            flexDirection: isMobile ? 'column' : undefined,
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridTemplateRows: 'auto auto',
            gap: '1rem',
            lineHeight: '2.25rem',
            marginBottom: '2rem',
          }}
        >
          <Card
            contentStyle={{
              padding: isMobile ? '1rem' : '1.5rem',
            }}
            style={{
              gridColumn: '1 / 3',
              gridRow: '1 / 3',
              textAlign: 'center',
              backgroundColor: 'var(--brand-accent)',
            }}
          >
            <Title.H3>
              {
                tSteunpunt.landing.whyCollectiveLiving.cards.independentAtHome
                  .title
              }
            </Title.H3>
            <Paragraph.Large>
              {
                tSteunpunt.landing.whyCollectiveLiving.cards.independentAtHome
                  .text
              }
            </Paragraph.Large>
            <Image
              src={IndependentLadiesImage}
              alt="Independent Ladies"
              style={{
                marginTop: 'auto',
                position: 'relative',
                left: isMobile ? '-4rem' : '-5rem',
                bottom: isMobile ? '-2rem' : '-3rem',
                width: isMobile ? '140%' : '130%',
              }}
            />
          </Card>

          <Card
            contentStyle={{
              padding: isMobile ? '1rem' : '1.5rem',
            }}
            style={{
              gridColumn: '3 / 4',
              gridRow: '1 / 2',
              textAlign: 'center',
              background: '#F8C75F',
            }}
          >
            <Title.H3>
              {
                tSteunpunt.landing.whyCollectiveLiving.cards.livingTogether
                  .title
              }
            </Title.H3>
            <Paragraph.Large>
              {tSteunpunt.landing.whyCollectiveLiving.cards.livingTogether.text}
            </Paragraph.Large>
          </Card>

          <Card
            contentStyle={{
              padding: isMobile ? '1rem' : '1.5rem',
            }}
            style={{
              gridColumn: '4 / 5',
              gridRow: '1 / 2',
              textAlign: 'center',
            }}
          >
            <Title.H3>
              {tSteunpunt.landing.whyCollectiveLiving.cards.homeFit.title}
            </Title.H3>
            <Paragraph.Large>
              {tSteunpunt.landing.whyCollectiveLiving.cards.homeFit.text}
            </Paragraph.Large>
          </Card>

          <Card
            contentStyle={{
              padding: isMobile ? '1rem' : '1.5rem',
            }}
            style={{
              gridColumn: '3 / 5',
              gridRow: '2 / 3',
              background: '#E5E0D7',
              backgroundBlendMode: 'screen, normal',
              boxShadow: '0 4px 20px 0 rgba(72, 43, 15, 0.05)',
              textAlign: isMobile ? 'center' : 'left',
            }}
            image={NeverAloneImage}
            imageStyle={{ flexBasis: '50%' }}
            orientation={isMobile ? 'vertical' : 'horizontal'}
          >
            <Title.H3>
              {tSteunpunt.landing.whyCollectiveLiving.cards.neverAlone.title}
            </Title.H3>
            <Paragraph.Large>
              {tSteunpunt.landing.whyCollectiveLiving.cards.neverAlone.text}
            </Paragraph.Large>
          </Card>
        </div>
      </div>

      <ColumnsSection
        style={{
          alignItems: 'stretch',
          gap: isMobile ? '1rem' : '4rem',
        }}
        columns={[
          {
            content: (
              <Card
                style={{
                  lineHeight: '2.25rem',
                  padding: isMobile ? '1rem' : '4rem',
                  background: '#F7EFDC',
                  height: '100%',
                }}
              >
                <Image
                  src={PersonWithBinocularsImage}
                  alt="Person with Binoculars"
                  style={{
                    height: '20rem',
                  }}
                />

                <Title.H2>
                  {tSteunpunt.landing.lookingForHousing.title}
                </Title.H2>
                <Paragraph.Large style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.lookingForHousing.text}
                </Paragraph.Large>

                <SignupFormModal style={{ marginTop: 'auto' }} />
              </Card>
            ),
            style: {
              alignItems: 'flex-start',
            },
          },
          {
            content: (
              <Card
                style={{
                  lineHeight: '2.25rem',
                  padding: isMobile ? '1rem' : '4rem',
                  background: '#FCC4B9',
                  height: '100%',
                }}
              >
                <Image
                  src={PeopleLookingForAHouse}
                  alt="People looking for a house"
                  style={{
                    height: '20rem',
                  }}
                />

                <Title.H2>{tSteunpunt.landing.registerGroup.title}</Title.H2>
                <Paragraph.Large style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.registerGroup.text}
                </Paragraph.Large>

                <SignupFormModal
                  triggerLabel={tSteunpunt.signupGroup.triggerLabel}
                  initialTab="group"
                  style={{ marginTop: 'auto' }}
                />
              </Card>
            ),
            style: {
              alignItems: 'flex-start',
            },
          },
        ]}
      />

      <ColumnsSection
        style={{ gap: isMobile ? '1rem' : '0' }}
        columns={[
          {
            content: (
              <>
                <Title.H2>{tSteunpunt.landing.whySteunpunt.title}</Title.H2>
                <Paragraph.Medium style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.whySteunpunt.text}
                </Paragraph.Medium>
              </>
            ),
            style: {
              paddingRight: isMobile ? '0' : '4rem',
            },
          },
          {
            content: (
              <>
                <Title.H2>{tSteunpunt.landing.forWhom.title}</Title.H2>
                <Paragraph.Medium style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.forWhom.text}
                </Paragraph.Medium>
              </>
            ),
            style: {
              borderLeft: isMobile
                ? 'none'
                : '2px solid var(--palette-beige-300)',
              paddingLeft: isMobile ? '0' : '4rem',
            },
          },
        ]}
      />

      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Title.H2 style={{ marginBottom: '3rem' }}>
            {tSteunpunt.landing.residentStories.title}
          </Title.H2>
          <TextLink to={pages.blogs()} icon={faArrowRight} size="medium">
            {t.common.seeMore}
          </TextLink>
        </div>
        <LandingStoryCards />
      </div>

      <ColumnsSection
        id="contact"
        style={{
          padding: isMobile ? '1rem' : '4rem',
          alignItems: 'center',
          flexDirection: isMobile ? 'column' : 'row-reverse',
          gap: isMobile ? '1rem' : '4rem',
        }}
        columns={[
          {
            content: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '140%',
                }}
              >
                <Image
                  src={PersonHoldingANut}
                  alt="Person offering help"
                  style={{ height: '20rem' }}
                />
              </div>
            ),
          },
          {
            content: (
              <>
                <Title.H2>{tSteunpunt.landing.questions.title}</Title.H2>
                <Paragraph.Large style={{ lineHeight: '2.25rem' }}>
                  {tSteunpunt.landing.questions.text}
                </Paragraph.Large>
                <Button
                  label={tSteunpunt.landing.questions.buttonLabel}
                  onClick={() =>
                    (window.location.href = `mailto:${tenantEmail}`)
                  }
                />
              </>
            ),
            style: {
              alignItems: isMobile ? 'center' : 'flex-start',
              textAlign: isMobile ? 'center' : 'left',
            },
          },
        ]}
      />
    </PageLayout>
  )
}
